import React, { Component } from 'react';

import { CrfContext } from '../../CrfContext';

import SideNav from '../sidenav/Sidenav.js';
import { Link } from 'react-router-dom';

import './Approved.css';

import axios from 'axios';
import { DownloadApproved } from '../downloadAsCSV/downloadAsCsv';
import CustomText from './customText.js';
export class Approved extends Component {
  state = {
    approvedRequest: false,
    allRequests: [],
  };

  componentDidMount() {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/status/forTransmittal`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        console.log(response);
        this.setState({
          allRequests: response.data.data,
        });
        //   console.log(this.state.myRequests)
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  formatDate = (date) => {
    const dateArray = date.split('-');
    let month = dateArray[1];
    const day = dateArray[2].substring(0, 2);
    const year = dateArray[0];
    switch (dateArray[1]) {
      case '02':
        month = 'Feb';
        break;
      case '03':
        month = 'Mar';
        break;
      case '04':
        month = 'Apr';
        break;
      case '05':
        month = 'May';
        break;
      case '06':
        month = 'Jun';
        break;
      case '07':
        month = 'Jul';
        break;
      case '08':
        month = 'Aug';
        break;
      case '09':
        month = 'Sep';
        break;
      case '10':
        month = 'Oct';
        break;
      case '11':
        month = 'Nov';
        break;
      case '12':
        month = 'Dec';
        break;
      default:
        month = 'Jan';
    }
    return `${month} ${day}, ${year}`;
  };

  sortList = (allRequests) => {
    const finalArray = [];
    allRequests.sort((a, b) => {
      return b.crfNo - a.crfNo;
    });
    allRequests.filter((element, index) => {
      if (index === 0 || element.number !== allRequests[index - 1].number) {
        finalArray.push(element);
      } else {
        finalArray.push(element);
      }
    });
    return finalArray;
  };

  render() {
    const allRequests = this.state.allRequests;

    return (
      <CrfContext.Consumer>
        {(context) => (
          <div id="mainPage">
            <div id="sidePanel">
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id="mainPanel">
              <div className="requestSelectionPanel">
                <div className="toApproveHeader">
                  <div>
                    <h1>Approved</h1>
                  </div>
                  <div style={{ position: 'absolute', left: '50rem', top: '2rem' }}>
                    {this.state.allRequests.length > 0 ? (
                      <button
                        onClick={() => {
                          DownloadApproved(this.state.allRequests);
                        }}
                        id="ph2Btn"
                        className="ph2Btn"
                      >
                        Download as CSV
                      </button>
                    ) : null}
                  </div>
                  {/* <div className="sortingButtons">
                            <button onClick={this.handleAllRequest}>
                                <span id="allSelected" className="sortBtnInitital">
                                    All Request
                                </span>
                            </button>
                            <button onClick={this.handleApprovedRequest}>
                                <span id="approvedSelected" className="sortBtn">
                                    Approved
                                </span>
                            </button>
                            <button onClick={this.handleTransmittedRequest}>
                                <span id="transmittedSelected" className="sortBtn">
                                    Transmitted
                                </span>
                            </button>
                            <button onClick={this.handleReviewedRequest}>
                                <span id="reviewedSelected" className="sortBtn">
                                    Reviewed
                                </span>
                            </button>
                            <button onClick={this.handleForEndorsementRequest}>
                                <span id="forEndorsementSelected" className="sortBtn">
                                    For Endorsement
                                </span>
                            </button>
                        </div> */}
                  {/* TABLE HEAD */}
                  <div className="myRequestTableHeader">
                    <div className="tHead">CRF#</div>
                    <div className="tHead">Date Created</div>
                    <div className="tHead">Due date</div>
                    <div className="tHead">Vendor</div>
                    <div className="tHead">Particulars</div>
                    <div className="tHead">Amount Requested</div>
                    <div className="tHead">Project</div>
                    <div className="tHead">Status</div>
                    <div className="tHead">Approver</div>
                  </div>
                  {/*END TABLE HEAD */}
                </div>
              </div>
              {/* TABLE DATA */}
              <div className="divisionToApprove"></div>
              {this.sortList(allRequests).map((requestsArray) => (
                <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
                  <div className="tableData" style={{ height: '60px' }}>
                    <div className="tData">
                      <h4>{requestsArray.crfNo}</h4>
                    </div>
                    <div className="tData">
                      <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
                    </div>
                    <div className="tData">
                      <h4>{this.formatDate(requestsArray.dueDate)}</h4>
                    </div>
                    <div className="tData">
                      <CustomText>{requestsArray.vendor.bpName}</CustomText>
                    </div>
                    <div className="tData">
                      <CustomText>{requestsArray.particulars}</CustomText>
                    </div>
                    <div className="tData">
                      <h4>
                        <span>&#8369;</span>
                        {requestsArray.totalNetPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                      </h4>
                    </div>
                    <div className="tData">
                      <CustomText>{requestsArray.project.projectName}</CustomText>
                    </div>
                    <div className="tData">
                      <h4>{requestsArray.status}</h4>
                    </div>
                    <div className="tData">
                      <h4>{`${requestsArray.departmentApprover.firstName} ${requestsArray.departmentApprover.lastName}`}</h4>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    );
  }
}

const link = {
  textDecoration: 'none',
  color: 'black',
};

export default Approved;
